// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { storyTestnet as _storyTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the storyTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1513
 * Chain Name: Story Testnet
 * Default Block Explorer: https://testnet.storyscan.xyz
 * Default RPC URL: https://testnet.storyrpc.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { storyTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: storyTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const storyTestnet = createCommon({
	..._storyTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
